import { IconPropsType } from '..';

export const CircleDefault = ({ ...props }: IconPropsType) => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_5038_201156)">
      <circle
        cx="5"
        cy="5"
        r="2"
        fill="#6A6F85"
      />
    </g>
    <defs>
      <clipPath id="clip0_5038_201156">
        <rect
          width="10"
          height="10"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
